export default __webpack_public_path__ + "static/media/avatar_dog8.a8e51e4a.mp3";